export default "/biometrie-afghanistan/media/35afcb67189ef321c5337991c88e4fdc~christian.jpg";